export const API_PATHS = {
    NORMAL_USER_LOGIN: '/auth',
    GET_VERSION: '/version',
    NORMAL_USER_FORGOT: '/forgot',
    ORG_REGISTRATION: 'organizations/register',
    PROJECTS_LIST: 'projects/list',
    PROJECTS_Add: 'projects',
    PROJECTS_Delete: 'projects/',
    ADMIN_PROJECTS_EXPORT_CSV: 'admin/projects/export-csv',
    ADMIN_PROJECTS_EXPORT_ALL_CSV: 'admin/projects/export-all-csv',
    PROJECTS_EXPORT_CSV: 'projects/export-csv',
    ADMIN_PROJECTS_LIST: 'admin/projects/list',
    GET_ORGANIZATION: 'organizations/',
    GET_ORGANIZATION_TRANSACTIONS: 'admin/organizations',
    UPDATE_BUSINESS_SETTINGS: 'organizations/',
    INVITE_MEMBER_BUSINESS_SETTINGS: 'invites',
    GET_PRICINGS: 'pricing/plans',
    ADMIN_LOGIN: '/admin/auth',
    CONTACT_US: '/contactus',
    PRIVATE_AREA_GET: '/user',
    PRIVATE_AREA_UPDATE: '/users',
    PRIVATE_AREA_LANGUAGE_UPDATE: '/users/language',
    PRIVATE_AREA_PASSWORD_UPDATE: '/user/pass',
    REVISIONS: '/revisions',
    ADMIN_ADD_BUSINESS: 'admin/organizations',
    ADMIN_TOP_UP: 'admin/topup',
    ADMIN_GET_ORGANIZATIONS_CSV: 'admin/organizations/csv',
    ADMIN_GET_IDF_DOWNLOAD_LOGS_CSV: 'admin/idf-download-logs/csv',
    ADMIN_GET_ORGANIZATIONS_LIST: 'admin/organizations/list',
    ADMIN_GET_ORGANIZATIONS_LIST_ORGANIZATION: 'admin/organizations/list-organization', // New endpoint
    ADMIN_GET_ORGANIZATION_ADMIN_DETAILS: 'admin/organizations', // Admin organization details
    ADMIN_DELETE_ORGANIZATION: 'admin/organizations',
    DELETE_REVISION: 'revisions',
    TICKETS: '/tickets',
    UPDATE_USER_PERMISSION: '/user/permission',
    USER_RESET_PASSWORD: '/newpass',
    FEATURES: '/features',
    CAD2DXF_CONVERT: '/cad2dxf/convert',
    REFRESH_TOKEN: '/auth/refresh',
    // Inspector feature
    INSPECTIONS_MY: '/inspections/my',
    INSPECTIONS: '/inspections', // base path to PATCH status and view
    // Inspection organizations
    INSPECTION_ORGANIZATIONS: '/organizations/inspection',
    INSPECTION_ORGANIZATION_INSPECTORS: '/organizations', // will be used as /organizations/:id/inspectors
    // Future: assign inspector from revision
}

export const USER_ROLES = {
  VIEWER: 'viewer',
  MEMBER: 'member',
  MANAGER: 'manager',
  ADMIN: 'admin',
  INSPECTOR: 'inspector',
  INSPECTOR_MANAGER: 'inspector_manager',
};
